export const styles = (theme) => ({
  root: {
    position: 'relative',
    overflowY: 'unset',
  },

  cardParagraph: {
    fontFamily: 'Poppins',
    color: theme.palette.text.secondary,
  },

  expansionPanelTitle: {
    fontFamily: 'Poppins',
    color: theme.palette.primary.main,
  },

  cardParagraphSpan: {
    position: 'relative',
    bottom: theme.spacing(1),
    wordBreak: 'break-word',
  },
  cardIcon: {
    marginRight: theme.spacing(1),
  },

  cardAdress: {
    fontWeight: 500,
    color: '#494949',
  },

  socialSection: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(0, 2),
  },

  icon: {
    color: '#bbb',
    display: 'block',
    marginBottom: theme.spacing(1),
    margin: theme.spacing(2.5, 4),
    width: 20,
    height: 20,
    // [theme.breakpoints.down('xs')]: {
    //   width: 15,
    //   height: 15,
    // },
  },

  iconLabel: {
    textAlign: 'center',
    fontWeight: 300,
    cursor: 'default',
    // [theme.breakpoints.down('xs')]: {
    //   fontSize: 12,
    // },
  },

  directions: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'fex-start',
  },

  shareIcon: {
    margin: theme.spacing(0, 1),
    position: 'relative',
    top: theme.spacing(0.5),
    fontWeight: 300,
  },

  shareSocial: {
    fontFamily: 'Poppins',
    color: theme.palette.text.secondary,
    fontWeight: 'bold',
    textAlign: 'center',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(1),
  },

  primary: {
    color: theme.palette.primary.main,
  },

  inappropriateContent: {
    marginTop: theme.spacing(3),
    fontSize: 12,
  },
})
